import { isTauri } from '@/tauri/utils';
import { isKinde, isOnPrem } from '@/utils/buildProfile';
import { useKindeBrowserClient } from '@kinde-oss/kinde-auth-nextjs';
import { type PropsWithChildren } from 'react';
import { KindeBrowserClientContext } from './kinde-browser-client-context.utils';

const IS_TAURI = isTauri();

const CloudKindeBrowserClientProvider = ({ children }: PropsWithChildren) => {
  const state = useKindeBrowserClient();

  return (
    <KindeBrowserClientContext.Provider value={state}>
      {children}
    </KindeBrowserClientContext.Provider>
  );
};

export const KindeBrowserClientProvider = ({ children }: PropsWithChildren) => {
  // ON-PREM-GATE: the Kinde browser SDK mounts only for a Kinde cloud build.
  // `isOnPrem` stays in the condition alongside `isKinde` per buildProfile.ts's
  // `isKinde` doc-comment — `AUTH_PROVIDER=kinde` is a permitted debug override
  // on an on-prem build, so `isKinde` alone must never be the DCE gate (F1).
  if (IS_TAURI || isOnPrem || !isKinde) {
    return <>{children}</>;
  }

  return <CloudKindeBrowserClientProvider>{children}</CloudKindeBrowserClientProvider>;
};
